
  <template>
    <svg
      xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 24 24" aria-hidden="true" :fill="color"
    >
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 5C7 4.44772 7.44772 4 8 4C8.55228 4 9 4.44772 9 5V10H15V5C15 4.44772 15.4477 4 16 4C16.5523 4 17 4.44772 17 5V10H20C21.1046 10 22 10.8954 22 12V13.5278C20.9385 12.5777 19.5367 12 18 12C16.223 12 14.6264 12.7725 13.5278 14H11C10.4477 14 10 14.4477 10 15C10 15.5523 10.4477 16 11 16H12.3414C12.1203 16.6256 12 17.2987 12 18C12 18.7013 12.1203 19.3744 12.3414 20H4C2.89543 20 2 19.1046 2 18V12C2 10.8954 2.89543 10 4 10H7V5ZM4 15C4 14.4477 4.44772 14 5 14C5.55228 14 6 14.4477 6 15C6 15.5523 5.55228 16 5 16C4.44772 16 4 15.5523 4 15ZM7 15C7 14.4477 7.44772 14 8 14C8.55229 14 9 14.4477 9 15C9 15.5523 8.55229 16 8 16C7.44772 16 7 15.5523 7 15Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.8536 15.1465L22.2071 17.5H14V16.5H19.7929L19.1464 15.8536L19.8536 15.1465Z"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M19.7929 19.5H14V18.5H22.2071L19.8536 20.8536L19.1464 20.1464L19.7929 19.5Z"></path>
    </svg>
  </template>
  <script>
    import { defineComponent } from "vue";

    export default defineComponent({
      name: "OiActionflowgatewayparallelFill",
      props: {
        size: {
          type: Number,
          default: 16
        },
        color: {
          type: String,
          default: "currentColor"
        }
      }
    });
  </script>
